import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6","key":"svg-0"}],["path",{"d":"M3 7l9 6l9 -6","key":"svg-1"}],["path",{"d":"M15 19l2 2l4 -4","key":"svg-2"}]]

const IconMailCheck = createReactComponent('outline', 'mail-check', 'MailCheck', __iconNode);

export default IconMailCheck;